import domtoimage from 'dom-to-image';
export const getFloorImageUrl = {
  data() {
    return {
      floorImageUrl: null
    }
  },
  methods: {
    getFloorImageUrl(aaa) {
      let that = this;
        // let node = document.querySelector('#floor-plan svg');
        let node = this.$refs['floor-plan'].querySelector('svg');
        let timer = setInterval(function(){
          if(node !== null){
            if (document.querySelector('#floor-plan svg') !== null){
              clearInterval(timer);
              domtoimage.toPng(node).then(function (dataUrl) {
                  that.floorImageUrl = dataUrl;
                  node.style.display = "none";
                })
                .catch(function (error) {
                  console.error('', error);
                });
            }
          }
          node = document.querySelector('#floor-plan svg');
        },300);
    }
  }
}

